import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrl: './confirmation-popup.component.scss'
})
export class ConfirmationPopupComponent {

  @Input() public confirmationMessage: any;

  constructor(private _activeModal: NgbActiveModal, private _modalConfig: NgbModalConfig) {
    // this._modalConfig.centered = true;
  }

  onNegativeClick() {
    this._activeModal.close();
  }

  onPositiveClick() {
    this._activeModal.close(true);
  }
}
